import { render, staticRenderFns } from "./ClassifyRow.vue?vue&type=template&id=581a5958&scoped=true"
import script from "./ClassifyRow.vue?vue&type=script&lang=js"
export * from "./ClassifyRow.vue?vue&type=script&lang=js"
import style0 from "./ClassifyRow.vue?vue&type=style&index=0&id=581a5958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a5958",
  null
  
)

export default component.exports